import { gql } from "lib/apolloClient";

import {
  staffCourseFragment,
  studentCourseFragment,
  staffCourseV2Fragment,
} from "Teacher/modules/TeacherFragments";

//Don't use it. Will deprecate. Use getUserCoursesQuery instead.
export const getStaffCoursesQuery = gql`
  query getStaffCoursesQuery(
    $id: ID!
    $filters: CourseFilter
    $courseGradeFilters: CourseGradeFilters
    $isCurriculumProgramFree: Boolean! = false
    $enabledModulesFilters: EnabledModulesFiltersInput
  ) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        ...staffItem
      }
    }
  }
  ${staffCourseFragment.staffCourse}
`;

export const getUserCoursesQuery = gql`
  query getUserCourses(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $filters: CourseFilter
    $isCurriculumProgramFree: Boolean! = false
    $courseGradeFilters: CourseGradeFilters
    $enabledModulesFilters: EnabledModulesFiltersInput
  ) {
    node(id: $id, type: $type) {
      id
      ... on Staff {
        ...staffItem
      }
      ... on Student {
        ...studentCourseItem
      }
    }
  }
  ${studentCourseFragment.studentCourse}
  ${staffCourseFragment.staffCourse}
`;

export const getUserCoursesIdQuery = gql`
  query getUserCoursesId(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $filters: CourseFilter
  ) {
    node(id: $id, type: $type) {
      id
      ... on Staff {
        id
        courses(filters: $filters) {
          id
        }
      }
      ... on Student {
        id
        courses(filters: $filters) {
          id
        }
      }
    }
  }
`;

export const getStudentCourseTagsQuery = gql`
  query getStudentCourseTags(
    $id: ID!
    $courseIdsFilter: UserCourseMapFilters!
  ) {
    node(id: $id, type: STUDENT) {
      id
      ... on Student {
        ...studentCourseTags
      }
    }
  }
  ${studentCourseFragment.studentCourseTags}
`;

export const getStaffCoursesStudentsQuery = gql`
  query getStaffCoursesStudents(
    $id: ID!
    $searchText: String
    $filters: CourseFilter
  ) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        ...staffItem
      }
    }
  }
  ${staffCourseFragment.StaffCourseStudents}
`;

export const getStaffCourseGenericFoldersBasicDetailsQuery = gql`
  query getStaffCourseGenericFoldersDetails(
    $id: ID!
    $folderType: FOLDER_TYPE_ENUM!
    $filters: CourseFilter
  ) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        ...staffItem
      }
    }
  }
  ${staffCourseFragment.staffCourseGenericFoldersBasicDetails}
`;

export const getStaffCoursesV2BasicDetailsQuery = gql`
  query getStaffCoursesBasicDetailsQuery(
    $id: ID!
    $first: Int
    $after: String
    $filters: CourseFilter
    $areStudentsIncluded: Boolean!
    $courseGradeFilters: CourseGradeFilters
    $enabledModulesFilters: EnabledModulesFiltersInput
    $aclControlParameterFilter: ACLControlParameterFilter
  ) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        ...staffItem
      }
    }
  }
  ${staffCourseV2Fragment.staffCourseBasicDetails}
`;

export const fetchMBSpontePortalUrlQuery = gql`
  query fetchMBSpontePortalUrl(
    $input: IntegrationMapleBearSpontePortalUrlInput!
  ) {
    integration {
      fetchMBSpontePortalUrl(input: $input) {
        isSuccess
        url
        errorMessage
        errorCode
      }
      __typename
    }
  }
`;

export const getUserThirdPartyRedirectionConfigsQuery = gql`
  query getUserThirdPartyRedirectionConfigs(
    $id: ID!
    $type: ENTITY_TYPE_ENUM!
    $filters: ThirdPartyRedirectionConfigFilterOptions
  ) {
    node(id: $id, type: $type) {
      id
      ... on Staff {
        id
        thirdPartyRedirectionConfigs(filters: $filters) {
          service
          redirectUrl
          customValue
          color
          imageUrl
          fieldUid
          canEditCustomValue
        }
      }
      ... on Student {
        id
        thirdPartyRedirectionConfigs(filters: $filters) {
          service
          redirectUrl
          customValue
          color
          imageUrl
          fieldUid
          canEditCustomValue
        }
      }
      ... on FamilyMember {
        id
        thirdPartyRedirectionConfigs(filters: $filters) {
          service
          redirectUrl
          customValue
          color
          imageUrl
          fieldUid
          canEditCustomValue
        }
      }
    }
  }
`;

export const getSamlIdpProviderDetailsQuery = gql`
  query getSamlIdpProviderDetails($id: ID!) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        samlSpProviderDetails {
          id
          serviceName
        }
      }
    }
  }
`;

export const getGlobalConstantsQuery = gql`
  query getGlobalConstants($id: ID!, $filter: GlobalConstantsFilterOptions) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        globalConstants(filter: $filter) {
          id
          name
          value
        }
      }
    }
  }
`;
